/**
 * Primitive color palettes
 * These are the base color scales used throughout the theme
 * Auto-generated from Tokens Studio exports - DO NOT EDIT MANUALLY
 * Run: npm run sync:tokens:primitives
 *
 * These colors have no semantic meaning - they are just color values.
 * Semantic tokens (like primary.color) map to these primitives.
 */
export const primitiveColors = {
  amber: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
    950: '#422006',
  },
  blue: {
    50: '#e6f1fb',
    100: '#b3d7f4',
    200: '#80bded',
    300: '#4da3e6',
    400: '#2681cf',
    500: '#005eb8',
    600: '#004b93',
    700: '#00386e',
    800: '#002649',
    900: '#001325',
    950: '#000912',
  },
  cyan: {
    50: '#ecfeff',
    100: '#cffafe',
    200: '#a5f3fc',
    300: '#67e8f9',
    400: '#22d3ee',
    500: '#06b6d4',
    600: '#0891b2',
    700: '#0e7490',
    800: '#155e75',
    900: '#164e63',
    950: '#083344',
  },
  emerald: {
    50: '#ecfdf5',
    100: '#d1fae5',
    200: '#a7f3d0',
    300: '#6ee7b7',
    400: '#34d399',
    500: '#10b981',
    600: '#059669',
    700: '#047857',
    800: '#065f46',
    900: '#064e3b',
    950: '#022c22',
  },
  fuchsia: {
    50: '#fdf4ff',
    100: '#fae8ff',
    200: '#f5d0fe',
    300: '#f0abfc',
    400: '#e879f9',
    500: '#d946ef',
    600: '#c026d3',
    700: '#a21caf',
    800: '#86198f',
    900: '#701a75',
    950: '#4a044e',
  },
  green: {
    50: '#e6f7ee',
    100: '#c2ebd4',
    200: '#8dd9b0',
    300: '#52c088',
    400: '#1f9f62',
    500: '#007f3b',
    600: '#006a31',
    700: '#005527',
    800: '#00401e',
    900: '#002c15',
    950: '#001f0f',
  },
  indigo: {
    50: '#eef2ff',
    100: '#e0e7ff',
    200: '#c7d2fe',
    300: '#a5b4fc',
    400: '#818cf8',
    500: '#6366f1',
    600: '#4f46e5',
    700: '#4338ca',
    800: '#3730a3',
    900: '#312e81',
    950: '#1e1b4b',
  },
  lime: {
    50: '#f7fee7',
    100: '#ecfccb',
    200: '#d9f99d',
    300: '#bef264',
    400: '#a3e635',
    500: '#84cc16',
    600: '#65a30d',
    700: '#4d7c0f',
    800: '#3f6212',
    900: '#365314',
    950: '#1a2e05',
  },
  orange: {
    50: '#fff4e6',
    100: '#ffe4c2',
    200: '#ffc89a',
    300: '#ffa866',
    400: '#ff8a3d',
    500: '#f56612',
    600: '#d95208',
    700: '#b33d06',
    800: '#8f3008',
    900: '#6b2307',
    950: '#3f0703',
  },
  pink: {
    50: '#fbf0f6',
    100: '#f4d1e3',
    200: '#edb2d0',
    300: '#e693bd',
    400: '#ca5c98',
    500: '#ae2573',
    600: '#8b1e5c',
    700: '#681645',
    800: '#460f2e',
    900: '#230817',
    950: '#11040c',
  },
  purple: {
    50: '#faf7fd',
    100: '#f3edfb',
    200: '#e7dbf7',
    300: '#d4bff0',
    400: '#ba9ae6',
    500: '#9d6fdb',
    600: '#7d3fc4',
    700: '#330072',
    800: '#280059',
    900: '#1d0042',
    950: '#0f0023',
  },
  red: {
    50: '#fef2f1',
    100: '#fde3e1',
    200: '#fbc7c3',
    300: '#f7a29b',
    400: '#f17069',
    500: '#d5281b',
    600: '#b91f15',
    700: '#9a1a12',
    800: '#7d160f',
    900: '#5f120b',
    950: '#150403',
  },
  rose: {
    50: '#fff1f2',
    100: '#ffe4e6',
    200: '#fecdd3',
    300: '#fda4af',
    400: '#fb7185',
    500: '#f43f5e',
    600: '#e11d48',
    700: '#be123c',
    800: '#9f1239',
    900: '#881337',
    950: '#4c0519',
  },
  sky: {
    50: '#f0f9ff',
    100: '#e0f2fe',
    200: '#bae6fd',
    300: '#7dd3fc',
    400: '#38bdf8',
    500: '#0ea5e9',
    600: '#0284c7',
    700: '#0369a1',
    800: '#075985',
    900: '#0c4a6e',
    950: '#082f49',
  },
  slate: {
    50: '#fafaf9',
    100: '#f5f5f4',
    200: '#e7e5e4',
    300: '#d1cfcc',
    400: '#9ca3af',
    500: '#6b7280',
    600: '#4b5563',
    700: '#2f4256',
    800: '#243242',
    900: '#1a1f26',
    950: '#0c1015',
  },
  teal: {
    50: '#f0fdfa',
    100: '#ccfbf1',
    200: '#99f6e4',
    300: '#5eead4',
    400: '#2dd4bf',
    500: '#14b8a6',
    600: '#0d9488',
    700: '#0f766e',
    800: '#115e59',
    900: '#134e4a',
    950: '#042f2e',
  },
  violet: {
    50: '#f5f3ff',
    100: '#ede9fe',
    200: '#ddd6fe',
    300: '#c4b5fd',
    400: '#a78bfa',
    500: '#8b5cf6',
    600: '#7c3aed',
    700: '#6d28d9',
    800: '#5b21b6',
    900: '#4c1d95',
    950: '#2e1065',
  },
  yellow: {
    50: '#fffbf0',
    100: '#fff4db',
    200: '#ffe8b8',
    300: '#ffd685',
    400: '#ffbf47',
    500: '#ffa500',
    600: '#ff8c00',
    700: '#e37200',
    800: '#b85c00',
    900: '#8a4500',
    950: '#4d2600',
  },
  // White color primitive
  white: '#ffffff',
};
